import { SyntheticEvent } from 'react';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { titleSmall } from 'styles-js/mixins/typography';
import InformationCard from 'src/components/informationCard';
import Button from 'src/components/buttons/button';

export default function HelpInfoBox({ text, buttonText, onClick }: { text: string, buttonText: string, onClick: (e: SyntheticEvent) => void }) {
  return (
    <Container>
      <InformationCard>
        <Title>{i18n.t("Not what you're looking for?")}</Title>
        <div>{text}</div>
        <StyledButton onClick={onClick}>{buttonText}</StyledButton>
      </InformationCard>
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 15px;
  @media (${props => props.theme.underScreenSmall}) {
    margin: 0 15px 15px;
  }
  @media (${props => props.theme.underScreenXsmall}) {
    margin: 0 10px 15px;
  }
`;

const Title = styled.div`
  ${titleSmall};
  padding-bottom: 10px;
`;

const StyledButton = styled(Button)`
  margin-top: 10px;
`;
